export type Settings = {
    pat: string;
    org: string;
    project: string;
};

export const ORG_OPTIONS = ['nuxni'] as const;
export const PROJECT_OPTIONS = ['C2D'] as const;

export const emptySettings: Settings = {
    pat: '',
    org: ORG_OPTIONS[0],
    project: PROJECT_OPTIONS[0],
};

export const isConfigured = (s: Settings): boolean => s.pat.trim() !== '' && s.org.trim() !== '' && s.project.trim() !== '';

export type TeamMember = {
    id: string;
    email: string;
    name: string;
    department: string;
    startDate: string | null;
    endDate: string | null;
};

// Mirrors the API's DayOffType / DayOffState. Rows synced from Sage carry
// the real policy; manual toggles are Other / Approved.
export type DayOffType = 'Vacation' | 'Sickday' | 'Other';
export type DayOffState = 'Approved' | 'AwaitingApproval';

export type DayOff = {
    date: string;
    type: DayOffType;
    state: DayOffState;
};

export const manualDayOff = (date: string): DayOff => ({ date, type: 'Other', state: 'Approved' });
